"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tree = _interopRequireDefault(require("britive-design-system/core/components/tree"));

var _constants = require("../constants");

var _constants2 = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SecretTree = function SecretTree(_ref) {
  var getImmediateNodes = _ref.getImmediateNodes,
      immediateNodes = _ref.immediateNodes,
      vaultName = _ref.vaultName,
      selectionHandler = _ref.selectionHandler,
      parentsOfSelectedItem = _ref.parentsOfSelectedItem;

  var _useState = (0, _react.useState)({
    label: vaultName,
    hasChildren: true,
    details: {
      entityType: 'node'
    },
    actionItems: [{
      title: _constants2.translatedStrings.noActionsAvailableText,
      isDisabled: true
    }],
    nodes: [],
    leaves: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      parentsWhereChildrenAreToBeAdded = _useState4[0],
      setParentsWhereChildrenAreToBeAdded = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedItemParents = _useState6[0],
      setSelectedItemParents = _useState6[1];

  (0, _react.useEffect)(function () {
    setTreeData(_objectSpread(_objectSpread({}, treeData), {}, {
      label: vaultName
    }));
    setSelectedItemParents([_objectSpread(_objectSpread({}, treeData), {}, {
      label: vaultName
    })]);
    selectionHandler([_objectSpread(_objectSpread({}, treeData), {}, {
      label: vaultName
    })]);
  }, [vaultName]);
  (0, _react.useEffect)(function () {
    setSelectedItemParents(parentsOfSelectedItem);
  }, [parentsOfSelectedItem]);
  (0, _react.useEffect)(function () {
    if (immediateNodes !== null && immediateNodes !== void 0 && immediateNodes.length) {
      var nodes = treeData.nodes;
      var updatedData = getUpdatedData(nodes, parentsWhereChildrenAreToBeAdded, immediateNodes, 'getNodes');
      setTreeData(_objectSpread(_objectSpread({}, treeData), {}, {
        nodes: updatedData
      }));
    }
  }, [immediateNodes]);

  var nodeClickHandler = function nodeClickHandler(ancestorsArray) {
    setSelectedItemParents(parentsOfSelectedItem);
    selectionHandler(ancestorsArray);
  };

  var expandIconClickHandler = function expandIconClickHandler(parents) {
    var newParents = parents.slice(1);
    setParentsWhereChildrenAreToBeAdded(newParents);
    getImmediateNodes(newParents);
  }; // This method will traverse through ancestorsArray starting from rootNodes and will insert elements of children
  // array into the required position


  var getUpdatedData = function getUpdatedData(rootNodes, ancestorsArray, children, action) {
    var _desiredNodes2;

    var nodesCopy = _toConsumableArray(rootNodes);

    var desiredNodes = nodesCopy;

    for (var i = 0; i < ancestorsArray.length; i++) {
      for (var j = 0; j < ((_desiredNodes = desiredNodes) === null || _desiredNodes === void 0 ? void 0 : _desiredNodes.length); j++) {
        var _desiredNodes;

        if (desiredNodes[j].label === ancestorsArray[i].label) {
          if (!desiredNodes[j].nodes) {
            desiredNodes[j].nodes = [];
          }

          desiredNodes = desiredNodes[j].nodes;
          break;
        }
      }
    }

    action === 'getNodes' ? desiredNodes.splice(0, (_desiredNodes2 = desiredNodes) === null || _desiredNodes2 === void 0 ? void 0 : _desiredNodes2.length) : null;

    for (var _i2 = 0; _i2 < children.length; _i2++) {
      if (children[_i2].entityType === 'node') {
        desiredNodes.push({
          label: children[_i2].name,
          hasChildren: true,
          details: {
            entityType: children[_i2].entityType
          },
          actionItems: [{
            title: _constants2.translatedStrings.noActionsAvailableText,
            isDisabled: true
          }]
        });
      }
    }

    return nodesCopy;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.nodesSecretsTreeContainer
  }, /*#__PURE__*/_react.default.createElement(_tree.default, {
    topPadding: "48px",
    nodes: treeData,
    clickHandler: nodeClickHandler,
    expandIconClickHandler: expandIconClickHandler,
    selectedItemParents: selectedItemParents
  }));
};

SecretTree.propTypes = {
  setPageHeader: _propTypes.default.func,
  vaultName: _propTypes.default.string.isRequired,
  createNode: _propTypes.default.func,
  getImmediateNodes: _propTypes.default.func,
  deleteNode: _propTypes.default.func,
  immediateNodes: _propTypes.default.any,
  parentsOfSelectedItem: _propTypes.default.array,
  newNodeData: _propTypes.default.any,
  deleteStatus: _propTypes.default.number,
  selectionHandler: _propTypes.default.func,
  history: _propTypes.default.any,
  match: _propTypes.default.any
};
var _default = SecretTree;
exports.default = _default;